import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { ImCross } from "react-icons/im";
import styles from "./DetailsDialog.module.scss";

function DetailsDialog(props) {
  const { filename, type, size, _id, createTime } = props.file;

  const readableDate = new Date(createTime).toLocaleDateString("en-us", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });

  const sizeInKb = size / 1024;
  const sizeInMb = sizeInKb / 1024;

  const fileDetails = [
    {
      Heading: "Name",
      Desc: filename,
    },
    {
      Heading: "Size",
      Desc: `${sizeInMb.toFixed(2)} MB`,
    },
    {
      Heading: "Type",
      Desc: type,
    },
    {
      Heading: "Date",
      Desc: readableDate,
    },
  ];
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <div className={styles.content}>
        <DialogTitle className={styles.caption}>
          <b>File properties</b>
          <ImCross onClick={props.handleClose} cursor="pointer" />
        </DialogTitle>
        <DialogContent>
          <table>
            {fileDetails.map((details) => {
              return (
                <tr>
                  <th>{details.Heading}:</th>
                  <td>{details.Desc}</td>
                </tr>
              );
            })}
          </table>
        </DialogContent>
      </div>
    </Dialog>
  );
}

export default DetailsDialog;
